import type { 
  GetProfileData,
  GetProfileResponse,

  GetMessengersData,
  GetMessengersResponse,

  GetTimezonesData,
  GetTimezonesResponse,

  GetCountriesData,
  GetCountriesResponse,

  GetRegionsData,
  GetRegionsResponse,

  GetMiscSitePaymentSystemsData,
  GetMiscSitePaymentSystemsResponse,

  GetMiscSportCategoriesData,
  GetMiscSportCategoriesResponse,

  GetMiscSportLeaguesData,
  GetMiscSportLeaguesResponse,

  GetPaymentMethodsData,
  GetPaymentMethodsResponse,

  GetMiscFilterTagsCountriesData,
  GetMiscFilterTagsCountriesResponse,

  GetMiscNoteTagsData,
  GetMiscNoteTagsResponse,

  GetPlatformUrlsData,
  GetPlatformUrlsResponse,

  GetLanguagesData,
  GetLanguagesResponse,

  GetCurrenciesData,
  GetCurrenciesResponse,

  GetCustomerCurrenciesData,
  GetCustomerCurrenciesResponse
} from '@/types/openapi-ts';
import type { AxiosInstance } from 'axios';
import * as qs from 'qs';

export function getMiscApiModule(affiliatesApi: AxiosInstance, miscApi: AxiosInstance) {
  return {
    getAdminInfo() {
      return affiliatesApi.get<GetProfileResponse>('/profile');
    },
    getMessengers() {
      return miscApi.get<GetMessengersResponse>('/messengers');
    },
    getTimezones() {
      return miscApi.get<GetTimezonesResponse>('/timezones');
    },
    getCountries() {
      return miscApi.get<GetCountriesResponse>('/countries');
    },
    getRegions() {
      return miscApi.get<GetRegionsResponse>('/regions');
    },
    getPaymentSystems() {
      return affiliatesApi.get<GetMiscSitePaymentSystemsResponse>('/misc/site-payment-systems');
    },
    getSportCategories(params: GetMiscSportCategoriesData['query']) {
      return affiliatesApi.get<GetMiscSportCategoriesResponse>('/misc/sport-categories', { params });
    },
    getSportLeagues(params: GetMiscSportLeaguesData['query']) {
      return affiliatesApi.get<GetMiscSportLeaguesResponse>('/misc/sport-leagues', { params });
    },
    getPaymentMethods(params?: GetPaymentMethodsData['query']) {
      return affiliatesApi.get<GetPaymentMethodsResponse>('/payment-methods', { params });
    },
    getCountryTags() {
      return affiliatesApi.get<GetMiscFilterTagsCountriesResponse>('/misc/filter-tags/countries');
    },
    getNoteTags() {
      return affiliatesApi.get<GetMiscNoteTagsResponse>('/misc/note-tags');
    },
    getPostPlatform() {
      return miscApi.get<GetPlatformUrlsResponse>('/platform-urls');
    },

    /**
     * Get available languages
     *
     * @param {Object} params
     * @param {String} [params.sort_column]
     * @param {String} [params.sort_dir]
     * @param {String} [params.search]
     * @param {Number} [params.limit]
     * @param {Number} [params.offset]
     * @param {String[]} [params.code]
     *
     * @return {Promise<Object>} api response
     */
    getLanguages(params?: GetLanguagesData['query']) {
      return miscApi.get<GetLanguagesResponse>('/languages', {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
      });
    },

    getCurrencies() {
      return miscApi.get<GetCurrenciesResponse>('/currencies');
    },

    getMiscCustomerCurrencies() {
      return miscApi.get<GetCustomerCurrenciesResponse>('/customer-currencies');
    },
  }
}
